// extracted by mini-css-extract-plugin
module.exports = {"menu_wrapper":"MoreDropdown_menu_wrapper__14iXf","menu":"MoreDropdown_menu__ZgR1s","dropdownMenu":"MoreDropdown_dropdownMenu__1KYeF"};